<template>  
  <div>    
  <b-modal
    id="view-flat-modal"
    title="Unit View Modal"
    centered
    hide-footer
    size="lg"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
    @show="onModalShow"
  >
    <div class="text-right mb-1">
      <b-button
        variant="danger"
        pill
        size="md"
        @click="createNewFlat()"
        v-if="hasPermission('create_flat')"
        
      >
        Add Flat
      </b-button>
    </div>
    <template #modal-title>
      <h2 class="m-0">View Units - {{ building.name }}</h2>
    </template>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="flats"
      details-td-class="m-0 p-0"
      small
      v-if="hasPermission('read_flat')"
      :per-page="0"
    >
      <template #cell(building_data)="row">
        {{
          row.item.building_data ? row.item.building_data.name : ""
        }}
      </template>

      <template #cell(floor_data)="row">
        {{
          row.item.floor_data ? row.item.floor_data.floor_no : ""
        }}
      </template>

      <template #cell(floor_data)="row">
        {{
          row.item.floor_data ? row.item.floor_data.floor_no : ""
        }}
      </template>

      <template #cell(owner_data)="row">
        {{
          row.item.owner_data ? row.item.owner_data.name : ""
        }}
      </template>
      
      <template #cell(manage)="row">
        <b-button
          variant="primary"
          pill
          size="sm"
          class="mr-50"
          @click="editFlat(row.item)"
          v-if="hasPermission('update_flat')"
        >
          Edit Flat
        </b-button>

        <b-button
          variant="danger"
          pill
          size="sm"
          class="mr-50"
          @click="downloadImage(row.item.qr_code_image_url)"
          v-if="hasPermission('show_qr_code')"
          :disabled="row.item.qr_code_image_url ? false:true"
        >
          Download QR
        </b-button>        
        
      </template>
    </b-table>
    <b-pagination
      size="md"
      :total-rows="totalItems"
      v-model="currentPage"
      :per-page="perPage"
    ></b-pagination>
  </b-modal>
  <EditFlatModal
    :flat="flat"
    :key="`editflat-${editFlatModalCount}`"
  />
  </div>  
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import util from "@/util.js";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import EditFlatModal from "@/components/building/EditFlatModal.vue";



export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    quillEditor,
    EditFlatModal, 
  },
  props: { building: Object },
  mixins: [util],
  data() {
    return {
      required,
      fields: [
        { key: "building_data", label: "Building Name" },
        { key: "floor_data", label: "Floor" },
        { key: "flat_no", label: "Flat No" },
        { key: "owner_data", label: "Owner" },
        
        { key: "manage", label: "Actions" },
      ],
      currentPage: 1,
      perPage: 0,
      totalItems: 0,
      flat: {},
      flats: [],
      editFlatModalCount: 0,
    };
  },
  methods: {
    ...mapActions({
      getFlats: "appData/getFlats",
    }),
    async fetchPaginatedData() {
      try {
        const res = await this.getFlats({
          pageNumber: this.currentPage,      
          building: this.building.id
        });
        this.flats = res.data.results;
        console.log(this.flats);
        this.totalItems = res.data.count;
        this.perPage = res.data.per_page;
      } catch (error) {
        this.displayError(error);
      }
    },
    
    downloadImage(imageUrl) {
      const link = document.createElement('a');
      link.href = imageUrl;
      link.download = 'qr_code_image'; 
      link.click();
    },

    editFlat(flat){
      this.flat = flat;
      this.editFlatModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("edit-flat-modal");
      });
      this.$nextTick(() => {
        this.$bvModal.hide("view-flat-modal");
      });
    },
   
    async onModalShow(){
      await this.fetchPaginatedData();
    },
    createNewFlat() {
      this.$emit('createFlat', this.building);
      this.$nextTick(() => {
        this.$bvModal.hide("view-flat-modal");
      });
    },
  },
  computed: {
    ...mapGetters({
      hasPermission: "appData/hasPermission",
    }),
  },
  watch: {
    currentPage: async function (val) {
      await this.fetchPaginatedData();
    },
  },
  
};
</script>

<style></style>
